<script>
  export let size = 14;
  export let fill = '#47675B';
</script>

<svg width={size} height={size} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.22933 11.8749C9.07129 11.8749 11.3752 9.57105 11.3752 6.72909C11.3752 3.88712 9.07129 1.58325 6.22933 1.58325C3.38736 1.58325 1.0835 3.88712 1.0835 6.72909C1.0835 9.57105 3.38736 11.8749 6.22933 11.8749Z"
    stroke={fill}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.9168 12.4166L10.8335 11.3333"
    stroke={fill}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
